// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607221015/js/" + chunkId + "." + {"44":"6768bd64","225":"af4ccb5e","481":"b12cbfff","486":"31899e17","770":"e4ef232d"}[chunkId] + ".0.26561542106151514.chunk.js";
};